import { render, staticRenderFns } from "./SeatableDataTable.vue?vue&type=template&id=23593399"
import script from "./SeatableDataTable.vue?vue&type=script&lang=js"
export * from "./SeatableDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports